(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dhariwal-bulk-enquiry-cta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-b2b-enquiry-link]');
    if (!link) return;

    const productRoot = link.closest('[data-product-id], product-information, .product-information') || document;
    const variantInput = productRoot.querySelector('input[name="id"], select[name="id"]');
    const variantId = variantInput?.value || new URL(window.location.href).searchParams.get('variant') || '';
    const destination = new URL(link.dataset.b2bPageUrl, window.location.origin);
    destination.searchParams.set('product_handle', link.dataset.b2bProductHandle);
    if (variantId) destination.searchParams.set('variant_id', variantId);
    link.href = destination.toString();
  });
  } catch(e) { console.error(e); }
})();

})();
